import React from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';

const videoItem = ({video, onVideoSelect}) =>{
    console.log(video)
    return(
          <Grid item xs={12} style={{paddingBottom: '12px'}}>
             <Paper style={{ display:'flex', cursor:'pointer'}} onClick={()=> onVideoSelect(video)}> 
                <img style={{marginRight: '10px', width: '50%', height:'150px'}} alt="Videos" src={video.snippet.thumbnails.medium.url}/>
                <Typography variant="subtitle1" style={{marginRight:'10px', fontSize:'12px', letterSpacing:'0px'}}><b>{video.snippet.title}</b><br/><br/> - {video.snippet.channelTitle}</Typography>
             </Paper>
          </Grid>
    )
}

export default videoItem;














